import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import { WalletTxnSearch } from "../dto/wallet/WalletTxnSearch";
import { ApiClient } from '../util/ApiUtility';
import { ReadResponse } from '../dto/response/ReadResponse';
import { WalletWithdrawalRequestSearch } from '../dto/wallet/WalletWithdrawalRequestSearch';
import { WalletWithdrawalRequestEntity } from '../dto/wallet/WalletWithdrawalRequestEntity';
import { BaseResponse } from '../dto/response/BaseResponse';

export const onWalletTxnSearch = async (data: WalletTxnSearch) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
        'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/wallet/txn/search',
        params: {
            walletId: data.walletId,
            offset: data.offset,
            limit: data.limit
        }
    }
  
    const response = await ApiClient().request<ReadResponse>(requestConfig);
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
  }

  export const onWalletWithdrawalRequestSearch = async (data: WalletWithdrawalRequestSearch) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/wallet/withdrawal-request/search',
        params: {
            id: data.id,
            phoneNo: data.phoneNo,
            nickname: data.nickname,
            status: data.status,
            offset: data.offset,
            limit: data.limit
        }
    }

    const response = await ApiClient().request<ReadResponse>(requestConfig);

    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}

export const onWalletWithdrawalApprove = async (id: number, adminNote?: string) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/wallet/withdrawal-request/approve',
        data: { id, adminNote }
    }

    const response = await ApiClient().request<BaseResponse<WalletWithdrawalRequestEntity>>(requestConfig);

    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}

export const onWalletWithdrawalReject = async (id: number, adminNote?: string) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/wallet/withdrawal-request/reject',
        data: { id, adminNote }
    }

    const response = await ApiClient().request<BaseResponse<WalletWithdrawalRequestEntity>>(requestConfig);

    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}